import { Component, OnInit } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { MapKeyService } from '../../../services';
import { MapKeyType } from '../../../enums/global/mapkey-type.enum';
import { MapKeysDropdownComponent } from '@Components/map-keys-dropdown/map-keys-dropdown.component';
import { FollowupDateConfigComponent } from '@Components/followup-date-config/followup-date-config.component';

@Component({
    selector: 'dynamic-action-form-control',
    templateUrl: './dynamic-action-form-control.component.html',
    styleUrls: ['./dynamic-action-form-control.component.scss'],
    imports: [SharedModule, MapKeysDropdownComponent, FollowupDateConfigComponent]
})
export class DynamicActionFormControlComponent implements OnInit {
    config;
    group: UntypedFormGroup;
    mapKeys: any[];
    virtualMapKeys: any[];
    mapKeyTypeEnum: any = MapKeyType;

    constructor(
        private mapkeyService: MapKeyService
    ) {
    }

    ngOnInit() {
        const nonListNonVirtualMapKeys = this.mapkeyService.nonListNonVirtualMapKeys;
        const virtualMapKeys = this.mapkeyService.virtualMapKeys;
        const nonListVirtualMapKeys = virtualMapKeys.filter(x => !x.IsList);
        this.mapKeys = [...nonListNonVirtualMapKeys, ...nonListVirtualMapKeys];
        this.virtualMapKeys = _.sortBy(virtualMapKeys, ['entityHierarchy']);
    }

}
